import {Component, Input, ViewEncapsulation} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {FroalaViewModule} from "angular-froala-wysiwyg";
import {LinkyModule} from "ngx-linky";

@Component({
  selector: 'app-tpiq-froala-view',
  standalone: true,
  imports: [CommonModule, FormsModule, FroalaViewModule, LinkyModule],
  templateUrl: './tpiq-froala-view.component.html',
  styleUrl: './tpiq-froala-view.component.scss',
  encapsulation: ViewEncapsulation.ShadowDom
})
export class TpiqFroalaViewComponent {
  @Input() data: any;
}
